module.exports = __webpack_public_path__ + "img/snakes.a88ce337.jpg";